import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NavBar: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  const { t } = useTranslation();
  const currentLang = lang || 'de';
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <Link to={`/${currentLang}`} className="navbar-brand">
        <span className="navbar-brand-main">CLAIRMONT</span>
        <span className="navbar-brand-sub">Rechtsanwalt Marcel Küster</span>
      </Link>
      <div className="navbar-links">
        <Link to={`/${currentLang}/portrait`}>{t('nav.portrait')}</Link>
        <Link to={`/${currentLang}/faq`}>{t('nav.faq')}</Link>
        <Link to={`/${currentLang}/glossary`}>{t('nav.glossary')}</Link>
        <Link to={`/${currentLang}/blog`}>{t('nav.blog')}</Link>
        <Link to={`/${currentLang}/contact`}>{t('nav.contact')}</Link>
        <Link to={`/${currentLang}/appointment`}>{t('nav.appointment')}</Link>
      </div>
    </nav>
  );
};

export default NavBar;
